module.exports = __webpack_public_path__ + "static/media/Bali-dennis-rochel.29128d9c.jpg";